export default "__VITE_ASSET__BeQfFdVW__"